export enum specimenUOM {
  Default = '',
  Straws = 'Straws',
  Pellets = 'Pellets',
  Embryo = 'Embryo',
  Goblet = 'Goblet',
}

export enum SpecimenTypeId {
  Semen = 1,
  Embryo = 2,
}
